import React from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { Icon, Table, Header, Popup, Segment, Loader } from 'semantic-ui-react';
import { IconHeader, HeaderCursor } from '../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoPreviousRequestMessage = () => <p><FormattedMessage id="studentDocuments.PreviousRequestMessage" /></p>;

export default class StudentsCertificateRequests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            previousRequestMode: true
        };
        this.activatePreviousRequest = this.activatePreviousRequest.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (localStorage.getItem('activeRole').substr(0, 11) === 'Diplomirani') {
            this.setState({ previousRequestMode: true });
        }
    }

    activatePreviousRequest() {
        this.setState({ previousRequestMode: !this.state.previousRequestMode });
    }
    render() {
        return (
            <Segment.Group raised>
                <Segment onClick={this.activatePreviousRequest} style={HeaderCursor}>
                    <Header as="h3">
                        <FormattedMessage id="studentDocuments.previousDocRequest" />
                        <Header style={IconHeader} floated="right" >
                            {this.state.previousRequestMode ? <Icon link circular basic floated="right" name="chevron up" />
                                : <Icon link circular basic floated="right" name={this.state.previousRequestMode ? 'chevron up' : 'chevron down'} />}
                        </Header>
                    </Header>
                </Segment>
                {this.props.loading ? <Segment><div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /></div></Segment> :
                    this.state.previousRequestMode && <Segment>
                        {this.props.data.length ?
                            <Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell><FormattedMessage id="studentDocuments.documentType" /></Table.HeaderCell>
                                        <Table.HeaderCell width="2"><FormattedMessage id="common.date" /></Table.HeaderCell>
                                        {/* <Table.HeaderCell>{<FormattedMessage id="common.language" />}</Table.HeaderCell> */}
                                        <Table.HeaderCell><FormattedMessage id="common.comment" /></Table.HeaderCell>
                                        <Table.HeaderCell width="3"><FormattedMessage id="studentDocuments.status" /></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>  {this.props.data.map((el) =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell verticalAlign="middle">
                                            {el.documentTypeName}<br />{el.certificateReasonName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.date}
                                        </Table.Cell>
                                        {/* <Table.Cell verticalAlign="middle"> */}
                                        {/* {el.language} */}
                                        {/* </Table.Cell> */}
                                        <Table.Cell verticalAlign="middle">
                                            {el.comment}
                                        </Table.Cell>
                                        <Table.Cell width="3" verticalAlign="middle" positive={el.documentStatusCategory === 'obrađen'} negative={el.documentStatusCategory !== 'obrađen' && el.documentStatusCategory !== 'primljen zahtjev'} warning={el.documentStatusCategory === 'primljen zahtjev'}>
                                            {el.documentStatusName}
                                            {el.documentStatusCategory === 'obrađen' ? <div style={{ float: 'right' }}><Icon name="checkmark" /> </div> : el.documentStatusCategory === 'primljen zahtjev' ? <div style={{ float: 'right' }}><Icon name="arrow down" /> </div>
                                                : <div style={{ float: 'right' }}><Icon name="close" /> </div>}
                                        </Table.Cell>
                                    </Table.Row>))
                                }
                                </Table.Body>
                            </Table>
                            : <NoPreviousRequestMessage />
                        }
                    </Segment>}
            </Segment.Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentsCertificateRequest/PreviousRequests.js